import api from "./api";
class ConfigService {
    private baseUrl = "/config";

    getCustomerEmail = async (): Promise<string | null> => {
        try {
            const { data } = await api.get(this.baseUrl + "/customer-email");
            return data.email;
        } catch (error) {
            console.error('Error getting customer email:', error);
            return null
        }
    }

    getStripePublicKey = async (): Promise<string | null> => {
        try {
            const { data } = await api.get(this.baseUrl + "/stripe-public-key");
            return data.key;
        } catch (error) {
            console.error('Error getting Stripe public key:', error);
            return null
        }
    }

    getDocumentUrl = async (): Promise<string | null> => {
        try {
            const { data } = await api.get(this.baseUrl + "/document-url");
            return data.url;
        } catch (error) {
            console.error('Error fetching document url', error);
            return null
        }
    }

    getDeploymentMode = async(): Promise<string | null > => {
        try {
            const { data } = await api.get(this.baseUrl + "/deployment-mode");
            return data.deploymentMode;
        } catch (error) {
            console.error('Error fetching deploymnet mode', error);
            return null
        }
    }

    getGtmContainerId = async(): Promise<string | null > => {
        try {
            const { data } = await api.get(this.baseUrl + "/gtm-container-id");
            return data.containerId;
        } catch (error) {
            console.error('Error fetching gtm-container id', error);
            return null
        }
    }
}

export default new ConfigService();